import type { RatingWithProductInfo } from '../server/controllers/rating';
import type { TFilters } from '../types/filters';

import { ProxyClient } from './client/ProxyClient';

export const getRating = async (params: TFilters): Promise<RatingWithProductInfo> => {
  const { data } = await ProxyClient.post<RatingWithProductInfo>('/ratings', params);

  return data;
};
